// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nmjS","content":"styles_content__38fts"};